/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal confirm-modal{display:block;max-width:500px}.modal confirm-modal>.modal-header{margin-bottom:10px}.modal confirm-modal>.mat-dialog-contents>.bold{font-weight:500}.modal confirm-modal>.mat-dialog-contents>p{font-size:1.5rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/confirm-modal/confirm-modal.component.scss.ngstyle.js.pre-build-optimizer.js